import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { Box, Typography } from "@material-ui/core";
import {
  CustomAutocomplete,
  CustomDialog,
} from "../../../../../../../Components";
import { useTranslate } from "../../../../../../../Hooks";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  GetActivityTypeById,
  GetAllReplyActivityType,
  GetAllSystemTemplateByCategoryId,
  OrganizationUserSearch,
} from "../../../../../../../Services";
import { TemplateCategoryEnum } from "../../../../../../../Enums";
import { config } from "../../../../../../../config";
import { useLocation } from "react-router";
import { ReplayActivityFormDialog } from "../ReplayActivityFormDialog";

// Styles
import useStyles from "./styles";

function ReplyActivityModalDialog({
  activeItem,
  open,
  close,
  isGeneralDialog,
}) {
  const styles = useStyles();
  const { translate } = useTranslate("NewContactsView");
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return { ...action.value };
  }, []);
  const allowedActivityTypeIds = [
    config.RejectWithCounterProposal,
    config.PriceNegotiationApproved,
    config.PriceNegotiationRejected,
  ];
  const searchTimer = useRef(null);
  const { pathname } = useLocation();
  const isSaleActivitiesView = pathname.includes("activities-sales");
  const isLeaseActivitiesView = pathname.includes("activities-lease");
  const isContactCenterActivitiesView =
    pathname.split("/home/")[1] === "Activities";
  const isLeadActivitiesView = pathname.includes("lead-profile-overview");
  const isMortgageActivitiesView = pathname.includes("activities-mortgage");
  const isUnitActivitiesView = pathname.includes("unit");
  const isContactActivitiesView = pathname.includes("contact-profile-overview");
  const isLeadOwnerActivitiesView = pathname.includes("lead-owner-activity");
  const [selected, setSelected] = useReducer(reducer, {
    activityAssign: null,
    activityType: null,
    relatedUnit: null,
    relatedLead: null,
    relatedContact: null,
    relatedPortfolio: null,
    relatedWorkOrder: null,
    relatedMaintenanceContract: null,
    reminderForOptions: [],
    reminderTypeOptions: [],
    durationType: 1,
    durationAmount: 0,
    ReminderforWhom: null,
    templete: [],
    activityReminders: [],
  });
  const [isEditDialog, setIsEditDialog] = useState(false);
  const [isWithReminder, setIsWithReminder] = useState();
  const [withDateTime, setwithDateTime] = useState(true);
  const [activityRelatedToList, setActivityRelatedToList] = useState([]);
  const [isRelatedToNotSelected, setIsRelatedToNotSelected] = useState(true);
  const [categoryName, setCategoryName] = useState(null);
  const [defaultReminders, setDefaultReminders] = useState(null);
  const [filter] = useState({ pageIndex: 0, pageSize: 25 });
  const [data, setData] = useReducer(reducer, {
    activityAssignments: [],
    activityTypes: [],
    reminderTemplates: [],
    relatedLead: [],
    relatedContact: [],
    relatedUnit: [],
    relatedPortfolio: [],
    relatedWorkOrder: [],
    relatedMaintenanceContract: [],
  });
  const [state, setState] = useReducer(reducer, {
    assignAgentId: null,
    activityTypeId: null,
    relatedUnitNumberId: null,
    relatedLeadNumberId: null,
    relatedContactNumberId: null,
    relatedActivityToId: null,
    relatedPortfolioId: null,
    relatedWorkOrderId: null,
    relatedMaintenanceContractId: null,
    activityDate: moment().add(2, "minutes").format("YYYY-MM-DDTHH:mm:ss"),
    activityEndDate: null,
    activityDuration: null,
    subject: null,
    comments: null,
    price: null,
    isApproved: false,
    isRejected: false,
    isRejectedWithCounterProposal: false,
    isOpen: true,
    activityReminders: [],
    createdByName: (loginResponse && loginResponse.fullName) || null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [loadings, setLoadings] = useReducer(reducer, {
    activityAssignments: false,
    activityTypes: false,
  });
  const [rols, setrols] = useState([]);
  const [isOpenFormDialog, setIsOpenFormDialog] = useState(false);

  const getAllSystemTemplateByCategoryId = useCallback(async () => {
    setLoadings({ id: "reminderTemplates", value: true });
    const res = await GetAllSystemTemplateByCategoryId(
      TemplateCategoryEnum.Activity.key
    );
    if (!(res && res.status && res.status !== 200)) {
      const mappedTempatesData = res?.map((item) => ({
        templateName: item.systemTemplateName,
        templateId: item.systemTemplateId,
      }));
      setData({ id: "reminderTemplates", value: mappedTempatesData || [] });
    } else {
      setData({ id: "reminderTemplates", value: [] });
    }
    setLoadings({ id: "reminderTemplates", value: false });
  }, []);

  const getAllActivityTypes = useCallback(async () => {
    setIsLoading(true);
    setLoadings({ id: "activityTypes", value: true });
    const res = await GetAllReplyActivityType(
      activeItem && activeItem.activityTypeId
    );
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: "activityTypes", value: res || [] });
    } else {
      setData({ id: "activityTypes", value: [] });
    }
    setLoadings({ id: "activityTypes", value: false });
    setIsLoading(false);
  }, [activeItem]);

  const getAllActivityAssignments = useCallback(
    async (value) => {
      setLoadings({ id: "activityAssignments", value: true });
      const res = await OrganizationUserSearch({
        ...filter,
        rolesIds: rols,
        name: (value && value.value) || "",
      });
      if (!(res && res.status && res.status !== 200)) {
        setData({
          id: "activityAssignments",
          value: (res && res.result) || [],
        });
      } else {
        setData({ id: "activityAssignments", value: [] });
      }
      setLoadings({ id: "activityAssignments", value: false });
    },
    [filter, rols]
  );

  const handleReminderForAgentOptions = (newValue) => {
    let itemToPush = {};
    const localReminderForOptions = [...selected.reminderForOptions];
    const assignToReminderIndex = localReminderForOptions.findIndex(
      (item) => item.type === "agent"
    );
    if (newValue) {
      itemToPush = {
        id: newValue.id,
        value: newValue.fullName,
        type: "agent",
      };
    }
    if (!newValue && assignToReminderIndex !== -1) {
      localReminderForOptions.splice(assignToReminderIndex, 1);
    }
    if (newValue && assignToReminderIndex !== -1) {
      localReminderForOptions[assignToReminderIndex] = itemToPush;
    }
    if (newValue && assignToReminderIndex === -1) {
      localReminderForOptions.push(itemToPush);
    }
    setSelected({ id: "reminderForOptions", value: localReminderForOptions });
  };

  const handleActivityRelatedToList = (relatedTo) => {
    if (relatedTo) {
      let filteredRelatedTo = [];
      if (
        isGeneralDialog ||
        isContactCenterActivitiesView ||
        isLeadOwnerActivitiesView ||
        isSaleActivitiesView ||
        isLeaseActivitiesView ||
        isLeadActivitiesView
      ) {
        filteredRelatedTo = relatedTo;
      } else if (isContactActivitiesView) {
        filteredRelatedTo = relatedTo.filter(
          (item) =>
            item.relatedToName === "Contact" || item.relatedToName === "Lead"
        );
      } else if (isUnitActivitiesView) {
        filteredRelatedTo = relatedTo.filter(
          (item) =>
            item.relatedToName === "Lead" ||
            item.relatedToName === "Unit" ||
            item.relatedToName === "Contact"
        );
      } else if (isMortgageActivitiesView) {
        filteredRelatedTo = relatedTo.filter(
          (item) =>
            item.relatedToName === "Lead" || item.relatedToName === "Contact"
        );
      }
      setActivityRelatedToList(filteredRelatedTo || []);
    } else {
      setActivityRelatedToList([]);
    }
  };

  const getActivityTypeById = useCallback(async () => {
    setLoadings({ id: "activityTypes", value: true });
    if (selected.activityType !== null) {
      const res = await GetActivityTypeById(state.activityTypeId);
      if (!(res && res.status && res.status !== 200)) {
        setIsWithReminder(res.withReminder);
        setwithDateTime(res.withDateTime);
        setDefaultReminders(res.activityTypeReminders);
        setCategoryName(res.categoryName);
        handleActivityRelatedToList(res.relatedTo);
      } else {
        setIsWithReminder(res.withReminder);
        setwithDateTime(res.withDateTime);
      }
    }
    setLoadings({ id: "activityTypes", value: false });
  }, [state.activityTypeId]);

  useEffect(() => {
    if (activeItem) getAllActivityTypes();
    getAllSystemTemplateByCategoryId();
  }, [activeItem]);

  useEffect(() => {
    if (state.activityTypeId) {
      getActivityTypeById();
      getAllActivityAssignments();
    }
  }, [state.activityTypeId]);

  useEffect(() => {
    if (activeItem) {
      setState({
        id: "edit",
        value: {
          ...state,
          relatedActivityToId: activeItem.activityId,
          relatedLeadNumberId: activeItem.relatedLeadNumberId || null,
          relatedUnitNumberId: activeItem.relatedUnitNumberId || null,
          relatedContactNumberId: activeItem.relatedContactNumberId || null,
          relatedPortfolioId: activeItem.relatedPortfolioId || null,
          relatedWorkOrderId: activeItem.relatedWorkOrderId || null,
          relatedMaintenanceContractId:
            activeItem.relatedMaintenanceContractId || null,
        },
      });
    }
  }, [activeItem]);

  return (
    <>
      <CustomDialog
        open={open}
        onClose={() => {
          close();
        }}
        title={translate("Add-Replay-Activity")}
        subtitle={translate(
          "add-Replay-and-schedule-new-activity-to-enhance-engagement-with-your-contacts-and-leads"
        )}
        width={"688px"}
        isDisabled={!state.activityTypeId || !state.assignAgentId}
        cancelText={translate("cancle")}
        confirmText={translate("Add-Replay-Activity")}
        onConfirm={() => {
          setIsOpenFormDialog(true);
        }}
        content={
          <Box className={styles.wrapperDialog}>
            <Box className={styles.containerInputFiled}>
              <Typography className={styles.titleInputFiled}>
                {translate("Activity-name")}*
              </Typography>
              <CustomAutocomplete
                placeholder={translate("Select")}
                options={data?.activityTypes || []}
                isDisabled={isEditDialog}
                onChange={(e, newValue) => {
                  setState({
                    id: "activityTypeId",
                    value: (newValue && newValue.activityTypeId) || null,
                  });
                  setSelected({ id: "activityType", value: newValue });
                  setState({
                    id: "subject",
                    value: (newValue && newValue.activityTypeName) || null,
                  });

                  allowedActivityTypeIds.includes(
                    newValue && newValue.activityTypeId
                  ) &&
                    setState({
                      id: "assignAgentId",
                      value: (activeItem && activeItem.assignedToId) || null,
                    });

                  const assignedToActivityTypeRoles =
                    (newValue && newValue.assignedToActivityTypeRoles) || [];
                  const rolesIds = assignedToActivityTypeRoles?.map(
                    (item) => item.rolesId || []
                  );
                  setrols(rolesIds);
                  setSelected({ id: "reminderForOptions", value: [] });
                }}
                value={selected?.activityType || null}
                getOptionLabel={(option) => option.activityTypeName || ""}
                getOptionValue={(option) => option.id === state.assignAgentId}
                renderOption={(option) => option.activityTypeName || ""}
              />
            </Box>
            <Box className={styles.containerInputFiled}>
              <Typography className={styles.titleInputFiled}>
                {translate("Activity-assign-to")}*
              </Typography>
              <CustomAutocomplete
                variant={"icon"}
                isDisabled={state.activityTypeId == null}
                options={data?.activityAssignments || []}
                value={selected?.activityAssign || null}
                getOptionLabel={(option) => option.fullName || ""}
                getOptionValue={(option) => option.id === state.assignAgentId}
                renderOption={(option) =>
                  ((option.userName || option.fullName) &&
                    `${option.fullName} (${option.userName})`) ||
                  ""
                }
                onInputKeyUp={(e) => {
                  const onSearch = e.target;
                  if (searchTimer.current) clearTimeout(searchTimer.current);
                  searchTimer.current = setTimeout(() => {
                    getAllActivityAssignments(onSearch);
                  }, 700);
                }}
                onChange={(e, newValue) => {
                  setSelected({ id: "activityAssign", value: newValue });
                  setState({
                    id: "assignAgentId",
                    value: (newValue && newValue.id) || null,
                  });
                  handleReminderForAgentOptions(newValue);
                }}
              />
            </Box>
          </Box>
        }
      />
      {isOpenFormDialog && (
        <ReplayActivityFormDialog
          isOpen={isOpenFormDialog}
          onClose={() => {
            setIsOpenFormDialog(false);
            close();
          }}
          state={state}
          setState={setState}
          selected={selected}
          setSelected={setSelected}
          data={data}
          setData={setData}
          categoryName={categoryName}
          activeItem={activeItem}
          activityRelatedToList={activityRelatedToList}
          setIsRelatedToNotSelected={setIsRelatedToNotSelected}
          isGeneralDialog
          isWithReminder={isWithReminder}
          withDateTime={withDateTime}
          setLoadings={setLoadings}
          loadings={loadings}
          close={close}
        />
      )}
    </>
  );
}

export default ReplyActivityModalDialog;
